import { useAppContext } from '@/Main';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';

type TextLoadingProps = {
  width?: number | string;
  height?: number;
  isWidthPx?: boolean;
};

const TextLoading = ({
  width,
  height,
  isWidthPx = false
}: TextLoadingProps) => {
  const {
    config: { theme }
  } = useAppContext() as { config: { theme: string } };

  const widthStyle = width
    ? isWidthPx
      ? `${width}px`
      : `${width}%`
    : '100%';

  return (
    <>
      <span
        className="text_chart_loading"
        style={{
          width: widthStyle,
          height: `${height ? `${height}px` : '10px'}`
        }}
      />
      <style>
        {`
            .text_chart_loading{
              background:${changeBgColor(theme)};
              background-size: 200% 100%;
              background-position: 100% 0;
            }
        `}
      </style>
    </>
  );
};

export default TextLoading;
